<template>
  <div>
    <div v-show="isLoading">
      <spin-loader />
    </div>
    <div v-show="!isLoading">
      <b-row>
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <invoicing-filter
            :visible-columns="tableColumns"
            @filter-change="updateFilter"
            @columns-change="updateColumns"
            @ready="syncLoad.ready('filter')"
          />
        </b-col>
      </b-row>
      <b-row
        class="justify-content-center mt-1"
      >
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <invoicing-table
            ref="refInvoicingTable"
            :filter="filter"
            :active="true"
            @ready="syncLoad.ready('table')"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'

import SpinLoader from '@/components/spinloader/SpinLoader.vue'
import SyncLoad from '@/components/utils/syncLoad'
import InvoicingFilter from './InvoicingFilter.vue'
import InvoicingTable from './InvoicingTable.vue'

export default {
  components: {
    BRow,
    BCol,
    SpinLoader,
    InvoicingTable,
    InvoicingFilter,
  },
  data() {
    const filter = {
      page_size: 10,
      search: '',
    }

    const isLoading = true
    const syncLoad = new SyncLoad()
    syncLoad.addTrigger('table')

    syncLoad.onReady(() => {
      this.isLoading = false
    })

    const tableColumns = [
      {
        key: 'id',
        label: 'Id',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'situation',
        label: 'Situação',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'note_number',
        label: 'Nº da Nota',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'delivery__id',
        label: 'Nº Entrega',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'delivery__company__corporate_name',
        label: 'Empresa',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'commitment__number',
        label: 'Empenho',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'commitment__order__contract__bidding__client__name',
        label: 'Órgão',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'delivery__date_delivery',
        label: 'Prazo da Entrega',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'delivery__invoicing_delivery_date',
        label: 'Data da Entrega',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'real_pay_date',
        label: 'Data de Pagamento',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'days_delay',
        label: 'Dias em Atraso',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'total_nf',
        label: 'Total da NF',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'liquid_margin',
        label: 'Margem Líquida',
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'status__name',
        label: 'Status',
        visible: true,
        fixedColumn: false,
      },
    ]

    return {
      filter,
      isLoading,
      syncLoad,
      tableColumns,
    }
  },
  methods: {
    updateFilter(val) {
      this.filter = val
    },
    updateColumns(val) {
      this.$refs.refInvoicingTable.refreshColumns(val)
    },
  },
  setup() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
</style>
